export default __webpack_public_path__ + "static/media/ImageBanner.3426702b.svg";